import React from 'react';

import BaseUserAvatar from '@embertracking/ui/components/UserAvatar';
import {protectedFileClient} from '-/data/protectedFiles';

// A station login has no users/{uid} doc: bootstrap builds it from the station,
// so its `image` is the station's photo, bound to stations/{id}. Asking for it
// under users/{uid} was refused on every load and the header fell back to the
// number.
export const avatarRecordPath = user => {
    if (user?.isStation && user.station) return `stations/${user.station}`;
    return user?.uid ? `users/${user.uid}` : null;
};

export default function UserAvatar(props) {
    return <BaseUserAvatar fileClient={protectedFileClient} recordPath={avatarRecordPath(props.user)} {...props} />;
}
